import { useHistoryBatch } from 'contexts/HistoryBatch';
import { StatusFile } from 'models/statusFile';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { HistoryBatchFile } from '../HistoryBatchFile';
import { ErrorSummary } from './ErrorSummary';
import { PartialProcessed } from './PartialProcessed';
import { Processed } from './Processed';
import { Processing } from './Processing';

export const HistoryBatchStatus = () => {
  const { selectedFile, fileDetails } = useHistoryBatch();
  const { t } = useTranslation(['history', 'beneficiaries']);

  if (!selectedFile) return null;

  const statusFile = selectedFile.status;

  const isEmptyCpf = fileDetails?.every((item) => item.cpf.trim() === '');

  const isPartial = statusFile === StatusFile.PARTIAL_PROCESSED;
  const isProcessed = statusFile === StatusFile.PROCESSED;
  const isProcessing = statusFile === StatusFile.PROCESSING;

  const isError = statusFile === StatusFile.ERROR;

  const isDeactivate = selectedFile?.filename?.includes('DS');

  return (
    <>
      {isPartial && <span className="subtitle">{t('details_subtitle')}</span>}
      <HistoryBatchFile />
      {isPartial && <PartialProcessed isDeactivate={isDeactivate} />}
      {isProcessed && <Processed />}
      {isProcessing && <Processing />}
      {isError &&
        (isEmptyCpf ? <ErrorSummary isDeactivate={isDeactivate} /> : <PartialProcessed isDeactivate={isDeactivate} />)}
      {!isProcessed && !isPartial && !isProcessing && !isError && <ErrorSummary isDeactivate={isDeactivate} />}
    </>
  );
};
